var map = {
	"./19.JPG": 195,
	"./20210501_091914726_iOS.jpg": 196,
	"./22.jpg": 197,
	"./Close-1.JPG": 198,
	"./CloseUp2.jpeg": 199,
	"./IMG-20230508-WA0172.jpg": 200,
	"./IMG-20230508-WA0173.jpg": 201,
	"./IMG-20230508-WA0175.jpg": 202,
	"./IMG-20230508-WA0176.jpg": 203,
	"./IMG-20230508-WA0177.jpg": 204,
	"./IMG-20230508-WA0178.jpg": 205,
	"./Veg.png": 206,
	"./WhatsApp Image 2021-02-23 at 22.46.54.jpeg": 207,
	"./WhatsApp Image 2021-02-23 at 22.49.29 (17).jpeg": 208,
	"./_23.jpg": 209,
	"./event-3.jpg": 210,
	"./event-6.JPG": 211
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 194;